import { AlertTriangleIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  isRouteErrorResponse,
  useNavigate,
  useRouteError,
} from 'react-router-dom';
import { Button } from '@/components/ui/button';

export const ErrorPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const error = useRouteError();

  const is404 = isRouteErrorResponse(error) && error.status === 404;

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="flex max-w-md flex-col items-center gap-6 text-center">
        <div className="flex h-20 w-20 items-center justify-center rounded-full bg-destructive/10">
          <AlertTriangleIcon className="h-10 w-10 text-destructive" />
        </div>

        <div className="space-y-2">
          <h1 className="font-bold text-2xl tracking-tight">
            {is404 ? t('error-page.not-found-title') : t('error-page.title')}
          </h1>
          <p className="text-muted-foreground">
            {is404
              ? t('error-page.not-found-description')
              : t('error-page.description')}
          </p>
        </div>

        <Button onClick={() => navigate('/')}>{t('error-page.go-home')}</Button>
      </div>
    </div>
  );
};
